function checkShouldInheritVariant(_a) {
    var animate = _a.animate, variants = _a.variants, inherit = _a.inherit;
    return inherit !== null && inherit !== void 0 ? inherit : (!!variants && !animate);
}

export { checkShouldInheritVariant };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/motion/utils/should-inherit-variant.js
// module id = 199
// module chunks = 0